/** Stripe product/price IDs mapped to plan tiers */
export const PLAN_CONFIG = {
  plus: {
    product_id: "prod_U1QnqJlPeugUYf",
    price_id: "price_1T3Nw1Anj7ptF6WYdnlmK7k0",
    label: "Flyt Pluss",
    price: "79 kr/mnd",
  },
  together: {
    product_id: "prod_U1Qo2SdOB8p7Ok",
    price_id: "price_1T3NwRAnj7ptF6WY4YpUTllR",
    label: "Flyt Sammen",
    price: "99 kr/mnd",
  },
} as const;

export type PlanKey = keyof typeof PLAN_CONFIG;
